<template>
  <modal-default
    ref="modal"
    title="Incomplete Status Automations"
    :short-circuit-close="true"
    is-wide
    @close="cancel"
  >
    <div class="mb-150">
      <p>Status has incomplete automations, do you want to run them?</p>
    </div>

    <div class="status_automations" v-if="exitStatusAutomations.length !== 0">
      <h3 class="status_automations--heading">Exit Status Automations</h3>
      <div class="status_automations--checkboxes">
        <form-field v-for="(automation, index) in exitStatusAutomations" :key="index">
          <b-checkbox
            :native-value="automation"
            v-model="selectedAutomations"
          >
            <span>{{ automation.label }}</span>
          </b-checkbox>
        </form-field>
      </div>
    </div>

    <div class="status_automations"  v-if="afterAllRequiredTasksCompletedAutomations.length !== 0">
      <h3 class="status_automations--heading">After All Required Tasks Completed Automations</h3>
      <div class="status_automations--checkboxes">
        <form-field v-for="(automation, index) in afterAllRequiredTasksCompletedAutomations" :key="index">
          <b-checkbox
            :native-value="automation"
            v-model="selectedAutomations"
          >
            <span>{{ automation.label }}</span>
          </b-checkbox>
        </form-field>
      </div>
    </div>

    <div class="status_automations"  v-if="timeBeforeStatusDueAutomations.length !== 0">
      <h3 class="status_automations--heading">X Time Before Status Due Automations</h3>
      <div class="status_automations--checkboxes">
        <form-field v-for="(timeAutomation, index) in timeBeforeStatusDueAutomations" :key="index">
          <b-checkbox
            :native-value="timeAutomation"
            v-model="selectedAutomations"
          >
            <span>{{ timeAutomation.automation.label }}</span>
          </b-checkbox>
        </form-field>
      </div>
    </div>

    <div class="status_automations"  v-if="timeAfterEntersStatusAutomations.length !== 0">
      <h3 class="status_automations--heading">X Time After Enters Status Automations</h3>
      <div class="status_automations--checkboxes">
        <form-field v-for="(timeAutomation, index) in timeAfterEntersStatusAutomations" :key="index">
          <b-checkbox
            :native-value="timeAutomation"
            v-model="selectedAutomations"
          >
            <span>{{ timeAutomation.automation.label }}</span>
          </b-checkbox>
        </form-field>
      </div>
    </div>

    <template v-slot:footer>
      <button-default @click="confirm">Confirm</button-default>
    </template>
  </modal-default>
</template>

<script>
import {defineComponent} from 'vue'
import {destroyModal} from "../../services/modals";
import utils from "../../services/utils";
import {ENUMS} from "../../services/enums";

export default defineComponent({
  name: "PromptCancelStatusAutomations",
  props: {
    automations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedAutomations: [],
    }
  },
  mounted() {
    this.$refs.modal.open();

    this.selectedAutomations = [
      ...this.exitStatusAutomations,
      ...this.afterAllRequiredTasksCompletedAutomations,
      ...this.timeBeforeStatusDueAutomations,
      ...this.timeAfterEntersStatusAutomations
    ]
  },
  computed: {
    exitStatusAutomations() {
      return utils.clone(this.automations).filter(a => {
        if (a.hook === ENUMS.AutomationHookEnum.ExitStatus.value) {
          return this.formatAutomationType(a)
        }
      })
    },
    afterAllRequiredTasksCompletedAutomations() {
      return utils.clone(this.automations).filter(a => {
        if (a.hook === ENUMS.AutomationHookEnum.AfterAllRequiredTasksCompleted.value) {
          return this.formatAutomationType(a)
        }
      })
    },
    timeBeforeStatusDueAutomations() {
      return utils.clone(this.automations).filter(a => {
        if (a.automation && a.automation.hook === ENUMS.AutomationHookEnum.XTimeBeforeStatusDue.value) {
          a.automation = this.formatAutomationType(a.automation)
          return a
        }
      })
    },
    timeAfterEntersStatusAutomations() {
      return utils.clone(this.automations).filter(a => {
        if (a.automation && a.automation.hook === ENUMS.AutomationHookEnum.XTimeAfterEntersStatus.value) {
          a.automation = this.formatAutomationType(a.automation)
          return a
        }
      })
    },
  },
  methods: {
    formatAutomationType(automation) {
      switch(automation.class_name) {
        case ENUMS.AutomationTypeEnum.AddTask.value:
          automation.label = ENUMS.AutomationTypeEnum.AddTask.label
          break
        case ENUMS.AutomationTypeEnum.EmailPrimaryContact.value:
          automation.label = ENUMS.AutomationTypeEnum.EmailPrimaryContact.label
          break
        case ENUMS.AutomationTypeEnum.ManageUsers.value:
          automation.label = ENUMS.AutomationTypeEnum.ManageUsers.label
          break
        case ENUMS.AutomationTypeEnum.NotifyUsers.value:
          automation.label = ENUMS.AutomationTypeEnum.NotifyUsers.label
          break
        case ENUMS.AutomationTypeEnum.SendWebhook.value:
          automation.label = ENUMS.AutomationTypeEnum.SendWebhook.label
          break
        case ENUMS.AutomationTypeEnum.TextPrimaryContact.value:
          automation.label = ENUMS.AutomationTypeEnum.TextPrimaryContact.label
          break
        case ENUMS.AutomationTypeEnum.UpdateTemperature.value:
          automation.label = ENUMS.AutomationTypeEnum.UpdateTemperature.label
          break
      }

      return automation
    },
    cancel() {
      destroyModal(this.$refs.modal);
    },
    confirm() {
      const emitValues = this.selectedAutomations.map(a => {
        return {
          id: a.id,
          class_name: a.class_name,
          hook: (a.automation) ? a.automation.hook : a.hook
        }
      })

      this.$emit('confirmed', emitValues)
      destroyModal(this.$refs.modal);
    },
  }
})
</script>

<style scoped lang="scss">
@import "../../styles/variables/variables";

.status_automations {
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0
  }

  &--heading {
    margin-bottom: 12px;
    font-size: 1.05rem;
    font-weight: bold;
  }
}
</style>
